import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { getXtreamServerUrl, useAuth } from '../../../contexts/AuthContext';

interface ProfileSummarySectionProps {
  focused: boolean;
}

const ProfileSummarySection: React.FC<ProfileSummarySectionProps> = ({ focused }) => {
  const { t } = useTranslation();
  const { authData } = useAuth();
  const summaryRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (focused) summaryRef.current?.focus();
  }, [focused]);

  if (!authData) {
    return (
      <div className="settings-section">
        <h2 className="settings-section__title">{t('settings.profileSummary.title', 'Perfil ativo')}</h2>
        <div className="settings-card">
          <p>{t('settings.profileSummary.noProfile', 'Nenhum perfil ativo.')}</p>
        </div>
      </div>
    );
  }

  const usesCode = authData.profileUsesCode === true || Boolean(authData.accessCode);

  return (
    <div className="settings-section">
      <h2 className="settings-section__title">
        {t('settings.profileSummary.title', 'Perfil ativo')}
      </h2>
      <div ref={summaryRef} className="settings-card" tabIndex={0}>
        <div className="settings-row">
          <span className="settings-row__label">{t('settings.profileSummary.name', 'Nome')}</span>
          <span className="settings-row__value">{authData.profileDisplayName || authData.user.username}</span>
        </div>
        <div className="settings-row">
          <span className="settings-row__label">{t('settings.profileSummary.username', 'Usuário')}</span>
          <span className="settings-row__value">{authData.user.username}</span>
        </div>
        {usesCode ? (
          <div className="settings-row">
            <span className="settings-row__label">{t('settings.profileSummary.code', 'Código')}</span>
            <span className="settings-row__value settings-row__value--code">{authData.accessCode}</span>
          </div>
        ) : (
          <div className="settings-row">
            <span className="settings-row__label">{t('settings.profileSummary.server', 'Servidor')}</span>
            <span className="settings-row__value">
              {authData.server.baseUrl || getXtreamServerUrl(authData.server)}
            </span>
          </div>
        )}
        <p className="settings-cleanup-row__desc">
          {t(
            'settings.profileSummary.manageOnWebsite',
            'Para adicionar, editar ou remover perfis, use o site de ativação.',
          )}
        </p>
      </div>
    </div>
  );
};

export default ProfileSummarySection;
